import { observer } from 'mobx-react-lite';
import { LoadingView } from './LoadingView';
import { useResolve } from '@/tsyringe-hooks/useResolve';
import ViewportLayout from './ViewportLayout';
import { AppStore } from './AppStore';
import { TOKEN_TopNavQuickActionsStore } from './TopNavQuickActionsStore';
import { TOKEN_ColorSquareMenuStore } from './ColorSquareMenuStore';
import { TOKEN_GameContainerStore } from './GameContainerStore';
import { TOKEN_GlobalMenuStore } from './GlobalMenuStore';
import { TOKEN_LoadingStore } from './LoadingStore';
import { TOKEN_ModalDialogStore } from './modalDialogs/ModalDialogStore';
import { TOKEN_ShareLinkStore } from './modalDialogs/ShareLinkStore';
import { TOKEN_NavigationStore } from './utility-stores/NavigationStore';
import { TOKEN_ProjectAccessStore } from './utility-stores/ProjectAccessStore';
import { TOKEN_ReplayStore } from './utility-stores/ReplayStore';
import { TOKEN_RunningActionStore } from './utility-stores/RunningActionStore';
import { TOKEN_ScreenResizeStore } from './utility-stores/ScreenResizeStore';
import { TOKEN_ThemeStore } from './utility-stores/ThemeStore';
import { TOKEN_UsersDialogStore } from './modalDialogs/UsersDialogStore';
import { TOKEN_ShareLinksDialogStore } from './modalDialogs/ShareLinksDialogStore';

const AppView = observer(() => {
  // Ensure we spin up singleton stores as they subscribe to events and manage state
  useResolve(TOKEN_ModalDialogStore);
  useResolve(TOKEN_ShareLinkStore);
  useResolve(TOKEN_NavigationStore);
  useResolve(TOKEN_ProjectAccessStore);
  useResolve(TOKEN_ReplayStore);
  useResolve(TOKEN_RunningActionStore);
  useResolve(TOKEN_ScreenResizeStore);
  useResolve(TOKEN_ThemeStore);
  useResolve(TOKEN_ColorSquareMenuStore);
  useResolve(TOKEN_GameContainerStore);
  useResolve(TOKEN_GlobalMenuStore);
  useResolve(TOKEN_LoadingStore);
  useResolve(TOKEN_TopNavQuickActionsStore);
  useResolve(TOKEN_UsersDialogStore);
  useResolve(TOKEN_ShareLinksDialogStore);

  const store = useResolve(AppStore);
  store.renderView();

  return (
    <LoadingView>
      <ViewportLayout />
    </LoadingView>
  )
})

export default AppView;
